// extracted by mini-css-extract-plugin
export default {"row":"_10e14001","inline":"_90370122"};